export default (field) => {
    const newField = field.substring(1);
    return "_" + camelToSnakeCase(newField);
}

const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);